import { messageContent } from '@/views/layout/front/components/systemMessages/type'

export const flowStrategys = {
  210: (h: any, data: messageContent, context: any) => {
    // 审批流程通知
    // data.taskGuid = data.objectId
    // data.flowType = 'approve'
    const formatData: messageContent = getFlowMsgType(data, 210)
    return flowRender(h, formatData, context)
  },
  233: (h: any, data: messageContent, context: any) => {
    // 业务流程通知
    // data.taskGuid = data.objectId
    // data.flowType = 'business'
    const formatData: messageContent = getFlowMsgType(data, 233)
    return flowRender(h, formatData, context)
  },
  230: (h: any, data: messageContent, context: any) => {
    // 审批流程完成通知
    // data.processId = data.objectId
    // data.flowType = 'approve'
    const formatData: messageContent = getFlowMsgType(data, 230)
    return flowRender(h, formatData, context)
  },
  234: (h: any, data: messageContent, context: any) => {
    // 业务流程完成通知
    // data.processId = data.objectId
    // data.flowType = 'business'
    const formatData: messageContent = getFlowMsgType(data, 234)
    return flowRender(h, formatData, context)
  }
}

function flowRender(h: any, data: messageContent, context: any) {
  return h('span', {}, [
    data.content,
    h(
      'span',
      {
        class: 'customer-name',
        onClick: () => {
          context.emit('clickFlow', data)
        }
      },
      '点击查看'
    )
  ])
}

export function getFlowMsgType(data: Recordable, msgType: number) {
  const temp: any = { ...data }
  let content = data.content || ''
  try {
    const conData = JSON.parse(data.content)
    content = conData?.content || content
  } catch (e) {
    console.log(e)
  }
  switch (msgType) {
    case 210:
      temp.taskGuid = data.objectId
      temp.flowType = 'approve'
      break
    case 230:
      temp.processId = data.objectId
      temp.flowType = 'approve'
      break
    case 233:
      temp.taskGuid = data.objectId
      temp.flowType = 'business'
      break
    case 234:
      temp.processId = data.objectId
      temp.flowType = 'business'
      break
  }
  temp.content = content
  console.log(temp, '打印')
  return temp
}
